module.exports = __webpack_public_path__ + "static/login-80dbfe4dbd118ffbb5344b52954e8fc7.svg";